import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { EditColorCollectionsButton } from "./components/color-collections/edit-color-collections-button";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";

const EditColorCollectionsContext = createContext();
export const useEditColorCollections = () =>
  useContext(EditColorCollectionsContext);
function EditColorCollectionsProvider({ data, children }) {
  return (
    <EditColorCollectionsContext.Provider value={data}>
      {children}
    </EditColorCollectionsContext.Provider>
  );
}

function EditColorCollectionsRenderer() {
  const elements = document.querySelectorAll(".react-edit-color-collection");
  if (!elements) return;

  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for EditColorCollections"
      );
    }

    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <EditColorCollectionsProvider data={initialProps}>
            <EditColorCollectionsButton />
          </EditColorCollectionsProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initEditColorCollections = () => {
  if (document.readyState !== "loading") {
    EditColorCollectionsRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", EditColorCollectionsRenderer);
  }
};
